import { render } from "./ContactStepComments.vue?vue&type=template&id=8d18c960"
import script from "./ContactStepComments.vue?vue&type=script&lang=js"
export * from "./ContactStepComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__